import { createDictationController as createController } from './controller.js';

/** The separate Vite entry bundles DSP and remains on the application's origin. */
export function createDictationController(callbacks, dependencies = {}) {
  return createController(callbacks, {
    workletUrl: '/static/dist/dictation-worklet.js?v=1.0.0',
    ...dependencies,
  });
}
